export default "__VITE_ASSET__C28TQd17__"